import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { MemberValuesFragment } from './member.fragments';

export const ACCOUNT_MEMBERS_REPORT = gql`
  mutation GetAccountMembersReport($input: AccountMembersInput!) {
    getAccountMembersReport(input: $input) {
      count
      results {
        ...memberValues
      }
    }
  }
  ${MemberValuesFragment}
`;

export function useGetAccountMembersReport({
  account_id,
  year,
  queryString,
  ticket_id,
  type,
  start_date,
  end_date,
}) {
  const [membersReportMutation] = useMutation(ACCOUNT_MEMBERS_REPORT);

  const result = useCallback(() => {
    return membersReportMutation({
      variables: {
        input: {
          account_id,
          year,
          ...(queryString ? { queryString } : null),
          ...(ticket_id ? { ticket_id } : null),
          ...(type ? { type } : null),
          ...(start_date ? { start_date } : null),
          ...(end_date ? { end_date } : null),
        },
      },
    });
  }, [
    membersReportMutation,
    account_id,
    year,
    queryString,
    ticket_id,
    type,
    start_date,
    end_date,
  ]);

  return result;
}
